var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__stroke",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.19,
    height: 20.63,
    viewBox: "0 0 20.19 20.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 20,
    height: 20,
    transform: "translate(0.095 0.315)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M5.592,40.218A6.1,6.1,0,0,1,5.9,38.3L2.425,35.648a10.386,10.386,0,0,0,0,9.136L5.9,42.124a6.1,6.1,0,0,1-.307-1.906",
    transform: "translate(-1.366 -29.903)",
    fill: "#fbbc05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M17.208,4.22a5.977,5.977,0,0,1,3.8,1.36l3-3A10.323,10.323,0,0,0,7.938,5.745L11.414,8.4a6.087,6.087,0,0,1,5.794-4.18",
    transform: "translate(-6.879 0)",
    fill: "#ea4335",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M17.208,80.061a6.087,6.087,0,0,1-5.794-4.18L7.938,78.535a10.3,10.3,0,0,0,9.27,5.746,9.844,9.844,0,0,0,6.73-2.571l-3.3-2.551a6.39,6.39,0,0,1-3.43.9",
    transform: "translate(-6.879 -63.651)",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M75.317,54.239a8.544,8.544,0,0,0-.235-1.875H65.457v3.985H71a4.645,4.645,0,0,1-2.11,3.083l3.3,2.551a10.259,10.259,0,0,0,3.13-7.744",
    transform: "translate(-55.127 -43.924)",
    fill: "#4285f4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g.bf37c931af249a0ab41c9349da53a585.svg";
export { ForwardRef as ReactComponent };